import { Anonymity, DeviceType, Role, Stage } from "../types/enums";
import { GroupedActivityTag } from "../types/groupedActivityTag";
import { Status } from "../types/inventoryData";
import { Option } from "../types/option";

export const deviceTypeOptions: Option[] = [
    { value: DeviceType.Elbow, label: "labels.elbow" },
    { value: DeviceType.Back, label: "labels.back" },
  ];
  
  export const anonymityOptions: Option[] = [
    { value: Anonymity.Known, label: "labels.known" },
    { value: Anonymity.Unknown, label: "labels.unknown" },
  ];
  
  export const UserTypeOptions = [
    { value: Role.PrecureAdmin, label: "labels.precureAdmin" },
    { value: Role.SolutionOwner, label: "labels.solutionOwner" },
    { value: Role.LocalCoordinator, label: "labels.localCoordinator" },
    { value: Role.Partner, label: "Partner"}
  ];
  
  export const stageOptions: Option[] = [
    { value: Stage.Preparation, label: "stage.preparation" },
    { value: Stage.NotStarted, label: "stage.notStarted" },
    { value: Stage.Started, label: "stage.measurement" },
    { value: Stage.Complete, label: "stage.result" },
  ];
  
  export const elbowMeasurementSystems: Option[] = [
    { value: 0, label: "cm" },
    { value: 1, label: "in" },
  ];

  export const groupedActivityTags : GroupedActivityTag[] = [
    {
      header: "tags.Cleaning",
      children: [
        { value: "tags.CleaningBendingDown" },
        { value: "tags.CleaningVerticalSurface" },
        { value: "tags.CleaningLifting" },
        { value: "tags.CleaningFloorWashMachine" },
        { value: "tags.CleaningFloorWashMop" },
        { value: "tags.CleaningVacuum" },
        { value: "tags.CleaningFlatSurface" },
        { value: "tags.CleaningWipingInteriorMop" },
        { value: "tags.CleaningAtHeights" },
      ],
    },
    {
      header: "tags.SlaughterHouse",
      children: [
        { value: "tags.SlaughterHousePalletizingBoxes" },
        { value: "tags.SlaughterHouseEvisceration" },
        { value: "tags.SlaughterHouseEviscerationLungs" },
        { value: "tags.SlaughterHouseCuttingPressingTheBreast" },
        { value: "tags.SlaughterHouseCuttingTrimmingNeck" },
        { value: "tags.SlaughterHouseCuttingDeboningWhileHanging" },
        { value: "tags.SlaughterHouseCuttingSeparatingVealShoulder" },
        { value: "tags.SlaughterHouseCuttingOffTheLoin" },  
        { value: "tags.SlaughterHouseCuttingPullingShoulderBlade" },
        { value: "tags.SlaughterHouseCuttingHeavyMeatPieces" },
        { value: "tags.SlaughterHouseCuttingLooseningPelvicBone" },//
        { value: "tags.SlaughterHouseCuttingWorkingOnVertebrae" },
        { value: "tags.SlaughterHouseHangingSausages" },
      ],
    },
    {
      header: "tags.HeavyIndustry",
      children: [
        { value: "tags.HeavyIndustryLifting" },
        { value: "tags.HeavyIndustryMachineryOperation" },
        { value: "tags.HeavyIndustryMaintenanceRepairs" },
        { value: "tags.HeavyIndustryFabricationAssembly" },
        { value: "tags.HeavyIndustrySafetyMonitoringCompliance" },
        { value: "tags.HeavyIndustryLogisticsMaterialHandling" },
        { value: "tags.HeavyIndustryQualityControl" },
        { value: "tags.HeavyIndustryProjectManagement" },
        { value: "tags.HeavyIndustryWeldingMetalworking" },
        { value: "tags.HeavyIndustryInspectionTesting" },
      ],
    },
    {
      header: "tags.SlaughterHouse",
      children: [
        { value: "tags.SlaughterHousePalletizingBoxes" },
        { value: "tags.SlaughterHouseEvisceration" },
        { value: "tags.SlaughterHouseEviscerationLungs" },
        { value: "tags.SlaughterHouseCuttingPressingTheBreast" },
        { value: "tags.SlaughterHouseCuttingTrimmingNeck" },
        { value: "tags.SlaughterHouseCuttingDeboningWhileHanging" },
        { value: "tags.SlaughterHouseCuttingSeparatingVealShoulder" },
        { value: "tags.SlaughterHouseCuttingOffTheLoin" },  
        { value: "tags.SlaughterHouseCuttingPullingShoulderBlade" },
        { value: "tags.SlaughterHouseCuttingHeavyMeatPieces" },
        { value: "tags.SlaughterHouseCuttingLooseningPelvicBone" },//
        { value: "tags.SlaughterHouseCuttingWorkingOnVertebrae" },
      ],
    },
    {
      header: "tags.HighRepetitiveWork",
      children: [
        { value: "tags.HighRepetitiveWorkAssemblyLineWork" },
        { value: "tags.HighRepetitiveWorkWarehouseLogistics" },
        { value: "tags.HighRepetitiveWorkFoodProcessingPackaging" },
        { value: "tags.HighRepetitiveWorkRetailCheckout" },
        { value: "tags.HighRepetitiveWorkTextileGarmentManufacturing" },
        { value: "tags.HighRepetitiveWorkWelding" },
        { value: "tags.HighRepetitiveWorkQualityControl" },
        { value: "tags.HighRepetitiveWorkSortingRecycling" },
      ],
    },
    {
      header: "tags.Kitchen",
      children: [
        { value: "tags.KitchenStationSpecificCooking" },
        { value: "tags.KitchenPrepWork" },
        { value: "tags.KitchenPlating" },
        { value: "tags.KitchenLifting" },
        { value: "tags.KitchenDishwash" },
        { value: "tags.KitchenCleaning" },
        { value: "tags.KitchenExpedition" },
      ],
    },
    {
      header: "tags.Laboratory",
      children: [
        { value: "tags.LaboratoryPipetting" },
        { value: "tags.LaboratoryPreparation" },
        { value: "tags.LaboratoryLifting" },
        { value: "tags.LaboratoryStaticWorkPosition" },
      ],
    },
    {
      header: "tags.LuggageHandling",
      children: [
        { value: "tags.LuggageHandlingLifting" },
        { value: "tags.LuggageHandlingMoving" },
        { value: "tags.LuggageHandlingWorkingInSmallAreas" },
      ],
    },
    {
      header: "tags.ManualHandlingOfPeople",
      children: [
        { value: "tags.ManualHandlingOfPeopleUsingCran" },
        { value: "tags.ManualHandlingOfPeopleTheDrawSheetMethod" },
        { value: "tags.ManualHandlingOfPeopleTheLogRoll" },
        { value: "tags.ManualHandlingOfPeopleThePivotTransfer" },
        { value: "tags.ManualHandlingOfPeopleTheTwoPersonLift" },
      ],
    },
    {
      header: "tags.Office",
      children: [
        { value: "tags.OfficeWorkingFromHome" },
        { value: "tags.OfficeWorkingInOffice" },
      ],
    },
    {
      header: "tags.Production",
      children: [
        { value: "tags.ProductionLifting" },
        { value: "tags.ProductionPackaging" },
        { value: "tags.ProductionAssemblyLine" },
        { value: "tags.ProductionFillingUp" },
        { value: "tags.ProductionRunner" },
      ],
    },
    {
      header: "tags.Transport",
      children: [
        { value: "tags.TransportDriving" },
        { value: "tags.TransportTruckDriving" },
        { value: "tags.TransportLifting" },
      ],
    },
    {
      header: "tags.Warehouse",
      children: [
        { value: "tags.WarehouseReceivingUnloadingGoods" },
        { value: "tags.WarehouseSortingStoringProducts" },
        { value: "tags.WarehousePickingPackingOrders" },
        { value: "tags.WarehouseInventoryManagement" },
        { value: "tags.WarehouseLoadingShippingGoods" },
        { value: "tags.WarehouseOperatingWarehouseEquipment" },
      ],
    },
    {
      header: "tags.Back",
      children: [
        { value: "tags.BackPain" },
        { value: "tags.BackHighPain" },
        { value: "tags.BackBadPosture" },
        { value: "tags.BackExtremePositions" },
        { value: "tags.BackFastMovements" },
        { value: "tags.BackPeakLoad" },
        { value: "tags.BackPeakLoadCore" },
        { value: "tags.BackMedianLoad" },
        { value: "tags.BackMedianLoadCore" },
        { value: "tags.BackStaticLoad" },
        { value: "tags.BackStaticLoadCore" },
      ],
    },
    {
      header: "tags.Elbow",
      children: [
        { value: "tags.ElbowPain" },
        { value: "tags.ElbowHighPain" },
        { value: "tags.ElbowPeakLoad" },
        { value: "tags.ElbowMedianLoad" },
        { value: "tags.ElbowStaticLoad" },
        { value: "tags.ElbowLackOfRest" },
      ],
    },
  ];

  export const industries = [
    { value: 1, label: "labels.agricultureForestryFishing" },
    { value: 2, label: "labels.miningQuarrying" },
    { value: 3, label: "labels.manufacturing" },
    {
      value: 4,
      label: "labels.electricityGasAir",
    },
    { value: 5, label: "labels.waterSupplyWasteManagement" },
    { value: 6, label: "labels.construction" },
    { value: 7, label: "labels.wholesaleRetailTrade" },
    { value: 8, label: "labels.transportationStorage" },
    { value: 9, label: "labels.accommodationFoodServices" },
    { value: 10, label: "labels.informationCommunication" },
    { value: 11, label: "labels.financialInsuranceActivities" },
    { value: 12, label: "labels.realEstateActivities" },
    {
      value: 13,
      label: "labels.professionalScientificTechnical",
    },
    { value: 14, label: "labels.administrativeSupportServices" },
    { value: 15, label: "labels.publicAdministrationDefense" },
    { value: 16, label: "labels.education" },
    { value: 17, label: "labels.healthSocialWorkActivities" },
    { value: 18, label: "labels.artsEntertainmentRecreation" },
    { value: 19, label: "labels.otherServiceActivities" },
    {
      value: 20,
      label: "labels.activitiesofHouseholdsasEmployers",
    },
    {
      value: 21,
      label: "labels.activitiesOfExtraterritorialOrganizations",
    },
    //Moved this so its in the bottom of the dropdown.
    { value: 0, label: "labels.other" },
  ];
  

  export const langs = [
    {
      label: "English",
      src: "https://precure-cdn.azureedge.net/files/mli-interface/gb.svg",
      value: ["en", "en-GB"],
    },
    {
      label: "Deutsch",
      src: "https://precure-cdn.azureedge.net/files/mli-interface/de.svg",
      value: ["de", "de-DE"],
    },
    {
      label: "Dansk",
      src: "https://precure-cdn.azureedge.net/files/mli-interface/dk.svg",
      value: ["da", "da-DK"],
    },
    {
      label: "Español",
      src: "https://precure-cdn.azureedge.net/files/mli-interface/es.svg",
      value: ["es"],
    },
    {
      label: "Français",
      src: "https://precure-cdn.azureedge.net/files/mli-interface/fr.svg",
      value: ["fr"],
    },
  ];
  
  
  export const productStatusOptions: Option[] = [
    { value: Status.Available, label: "Available" },
    { value: Status.InUse, label: "InUse" },
    { value: Status.QA, label: "QA" },
    { value: Status.Defect, label: "Defect" },
  ];